import $ from 'jquery'
import 'slick-carousel'

export default () => {
  $('.slick-hero').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 2500,
    pauseOnHover: false,
    fade: true,
    dots: true,
    arrows: false,
    centerMode: false,
    centerPadding: '50px',
    cssEase: 'linear',
    rows: 1,
    slidesPerRow: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    zIndex: 0
  })

  $('.slick-act-media').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })

  // Slick slider grundsettings
  $('.slickreferenser').slick({
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 1500,
    pauseOnHover: false,
    fade: true,
    dots: false,
    arrows: false,
    centerMode: false,
    centerPadding: '50px',
    cssEase: 'linear',
    rows: 1,
    slidesPerRow: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    zIndex: 0,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          arrows: false
        }
      }
    ]
  })
}
